<template>
  <div class="flex flex-col gap-8">
    <ReassuranceItem>
      <template #icon>
        <IconGift size="32" />
      </template>
      <template #title>
        {{ i18n(translations.techTheirWayTitle) }}
      </template>
      <template #subtitle>
        {{ i18n(translations.techTheirWaySubtitle) }}
      </template>
    </ReassuranceItem>

    <ReassuranceItem v-if="market.countryCode === 'US'">
      <template #icon>
        <IconCalendarWithCheck size="32" />
      </template>
      <template #title>
        {{ i18n(translations.doesNotExpireTitle) }}
      </template>
      <template #subtitle>
        {{ i18n(translations.doesNotExpireSubtitle) }}
      </template>
    </ReassuranceItem>

    <ReassuranceItem v-else>
      <template #icon>
        <IconCalendarWithCheck size="32" />
      </template>
      <template #title>
        {{ i18n(translations.sixMonthsValidityPeriodTitle) }}
      </template>
      <template #subtitle>
        {{ i18n(translations.sixMonthsValidityPeriodSubtitle) }}
      </template>
    </ReassuranceItem>

    <ReassuranceItem has-link @click="openModal(MODAL_NAMES.GIFT_CARDS_FAQ)">
      <template #icon>
        <IconBill size="32" />
      </template>
      <template #title>
        {{ i18n(translations.faqTitle) }}
      </template>
      <template #subtitle>
        {{ i18n(translations.faqSubtitle) }}
      </template>
    </ReassuranceItem>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { openModal } from '@ds/components/ModalBase'
import { IconBill } from '@ds/icons/IconBill'
import { IconCalendarWithCheck } from '@ds/icons/IconCalendarWithCheck'
import { IconGift } from '@ds/icons/IconGift'

import { MODAL_NAMES } from '~/scopes/gift-cards/constant'

import ReassuranceItem from './ReassuranceItem/ReassuranceItem.vue'
import translations from './ReassuranceItems.translations'

const i18n = useI18n()
const { market } = useMarketplace()
</script>
